// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"userDetails_wrapper_3YU2H"};